import React from "react";

interface SelectInputProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "value" | "onChange"> {
    label?: string;
    options: { value: string; label: string }[];
    value: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    className?: string;
}

const SelectInput: React.FC<SelectInputProps> = ({ label, options, value, onChange, name, className, ...selectProps }) => {
    return (
        <div className="flex flex-col gap-1">
            {label && <label className="text-sm font-semibold">{label}</label>}
            <select
                name={name}
                value={value}
                onChange={onChange}
                {...selectProps}
                className={`border px-3 py-2 rounded ${className}`}
            >
                <option value="" disabled>Select an option</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SelectInput;
